export default __webpack_public_path__ + "static/media/DSC_0513.fcf82a77.jpg";